import { render } from "./ItemReceive_list.vue?vue&type=template&id=2bf2aa6e"
import script from "./ItemReceive_list.vue?vue&type=script&lang=js"
export * from "./ItemReceive_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__